import type { OrderItem, FulfillmentMode } from '../types';
import { canPickWarehouse } from './warehousePick';

export interface PosItemError {
  seller?: boolean;
  /** [BỎ TRƯỜNG CHỦ KHO] nhân viên kho (C.Kho) — hiện không còn dùng. */
  warehouse?: boolean;
  /** Chưa chọn kho xuất hàng (TCR-629) — chỉ áp dụng khi `canPickWarehouse`. */
  warehousePick?: boolean;
}

/**
 * Validate per-item required fields.
 * - seller (N.Bán) [BỎ N.BÁN + NV CHĂM SÓC] không còn bắt buộc ở mode nào —
 *   cột N.Bán đã bị gỡ khỏi UI nên không thể nhập. BE cũng đã nới optional.
 * - warehouse (C.Kho) [BỎ TRƯỜNG CHỦ KHO] không còn bắt buộc ở mode nào —
 *   cột C.Kho đã bị gỡ khỏi UI nên không thể nhập.
 * - warehousePick: kho xuất hàng bắt buộc đúng với những dòng CHỌN ĐƯỢC kho —
 *   giao ngay + hàng quản lý theo số lượng (không serial). Hàng serial lấy kho
 *   theo serial, PREORDER chưa xuất kho, nên hai trường hợp đó bỏ qua.
 * Returns a map keyed by item id; only items with at least one error are present.
 */
export function validatePosItems(
  items: OrderItem[],
  fulfillmentMode: FulfillmentMode,
): Record<string, PosItemError> {
  // [BỎ TRƯỜNG CHỦ KHO] khôi phục dòng dưới để bật lại validate C.Kho khi INSTANT.
  // const requireWarehouse = fulfillmentMode !== 'PREORDER';
  const requireWarehouse = false;
  // [BỎ N.BÁN + NV CHĂM SÓC] Cột N.Bán đã gỡ khỏi bảng hàng POS nên không thể
  // nhập → giữ ràng buộc này sẽ chặn mọi đơn. BE cũng đã nới thành optional.
  // Khôi phục: đổi dòng dưới về `const requireSeller = true;`
  const requireSeller = false;
  const errors: Record<string, PosItemError> = {};
  for (const item of items) {
    const e: PosItemError = {};
    if (requireSeller && !item.sellerStaffId) e.seller = true;
    if (requireWarehouse && !item.warehouseStaffId) e.warehouse = true;
    if (canPickWarehouse(item, fulfillmentMode) && !item.warehouseId) e.warehousePick = true;
    if (e.seller || e.warehouse || e.warehousePick) errors[item.id] = e;
  }
  return errors;
}
